module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/price-background-05c0aa979e8e335cf7ec455680410fc4.png";